module.exports = __webpack_public_path__ + "img/medicos-inativos.94237382.svg";